import { IApiResponse } from 'src/app/core/interfaces/api/api-response.interface';
import { IDocumentType } from 'src/app/core/interfaces/common/document/document-type.interface';
import { IDocument } from 'src/app/core/interfaces/common/document/document.interface';

export abstract class AbstractDocumentService {
  abstract getDocumentTypes(): Promise<IDocumentType[]>;
  abstract deleteDocumentById(id: number): Promise<IApiResponse>;
  abstract deleteDocumentByParams(queryParams: string): Promise<IApiResponse>;
  abstract uploadEnrollmentDocument(model: {
    files: File[];
    documentTypeId: number;
  }): Promise<IApiResponse>;
  abstract getEnrollmentDocumentsById(docId: string): Promise<IDocument[]>;
  abstract getMsaUrl(): Promise<string>;
}
